import api, { APIURL, errorHandle } from '../api/api'

class LoginUser {
    constructor(data) {
        this.username = data.username
        this.password = data.password
    }

    serialized() {
        return {
            "username": this.username,
            "password": this.password
        }
    }

}

export const postLogin = (data) => {
    return new Promise((resolve, reject) => {
        api.post(APIURL.LOGIN, data)
            .then(response => {
                if (response.data.data) {
                    resolve(response.data.data)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export default LoginUser